import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import { getPowerHourStatus, formatPowerHourRemaining } from '../lib/powerHour';

/**
 * Sticky global banner shown during Power Hour.
 * Fixed to the top of the viewport, above the nav.
 * Hidden entirely when Power Hour is not active.
 */
function PowerHourBanner() {
  const [status, setStatus] = useState(() => getPowerHourStatus());

  useEffect(() => {
    const tick = () => setStatus(getPowerHourStatus());
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  if (!status.isActive) return null;

  const remaining = formatPowerHourRemaining(status.msUntilEnd);

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1301, // above MUI AppBar (1100) and Drawer (1200)
        background: 'linear-gradient(90deg, #ff9800 0%, #ff5722 50%, #ff9800 100%)',
        backgroundSize: '200% 100%',
        animation: 'powerShimmer 3s linear infinite',
        color: 'white',
        py: 0.75,
        px: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        fontFamily: '"VT323", monospace',
        letterSpacing: 1,
        fontSize: '1.1rem',
        textShadow: '0 1px 2px rgba(0,0,0,0.35)',
        borderBottom: '2px solid rgba(0,0,0,0.2)',
        '@keyframes powerShimmer': {
          '0%':   { backgroundPosition: '0% 50%' },
          '100%': { backgroundPosition: '200% 50%' },
        },
        '@keyframes boltPulse': {
          '0%, 100%': { transform: 'scale(1)', opacity: 1 },
          '50%': { transform: 'scale(1.2)', opacity: 0.85 },
        },
      }}
    >
      <BoltIcon sx={{ animation: 'boltPulse 1.2s ease-in-out infinite' }} />
      <Typography
        component="span"
        sx={{ fontFamily: 'inherit', fontSize: 'inherit', letterSpacing: 'inherit', fontWeight: 700 }}
      >
        POWER HOUR — ALL TIME COSTS 50% OFF — {remaining} LEFT
      </Typography>
      <BoltIcon sx={{ animation: 'boltPulse 1.2s ease-in-out infinite' }} />
    </Box>
  );
}

export default PowerHourBanner;
